import React from "react";
import withStyles from "react-jss";
import { LazyImage } from "react-lazy-images";
import { PurplePopup } from "./../index";

const styles = theme => ({
    root: {
        maxWidth: "80%",
    },
    img: {
        maxHeight: "60px",
        maxWidth: "100%",
        cursor: "pointer",
    },
    popupContent: {},
    textWrapper: {
        position: "relative",
        textAlign: "center",
    },
    primaryText: {
        fontFamily: theme.fonts.medium,
        fontSize: "14px",
        letterSpacing: "2px",
        color: theme.palette.colors.white,
        textTransform: "uppercase",
    },
    secondaryText: {
        fontFamily: theme.fonts.medium,
        fontSize: "12px",
        transform: "translateX(100%)",
        color: theme.palette.colors.white,
        right: "-6px",
        top: "-9px",
        position: "relative",
    },
    rating: {
        marginBottom: "16px",
        padding: "0 15px",
        textAlign: "center",
    },
    noRating: {
        fontFamily: theme.fonts.medium,
        fontSize: "12px",
        letterSpacing: "2px",
        color: theme.palette.colors.white,
        textTransform: "uppercase",
    },
    [`@media (max-width: ${theme.media.lg})`]: {
        root: {
            display: "flex",
            justifyContent: "center",
        },
    },
});

function ProviderLogo({
    classes,
    webpTransformer,
    path,
    position,
    name,
    rating,
    texts,
    onReviewClick,
    reviewsCounter,
    windowSizes,
}) {
    return (
        <div className={classes.root}>
            {windowSizes.xs ? (
                <LazyImage
                    src={!!webpTransformer ? webpTransformer(path) : path}
                    placeholder={({ imageProps, ref }) => (
                        <img ref={ref} className={classes.img} alt={name} />
                    )}
                    actual={({ imageProps }) => (
                        <img
                            {...imageProps}
                            className={classes.img}
                            alt={name}
                        />
                    )}
                />
            ) : (
                <PurplePopup
                    element={
                        <LazyImage
                            src={
                                !!webpTransformer ? webpTransformer(path) : path
                            }
                            placeholder={({ imageProps, ref }) => (
                                <img
                                    ref={ref}
                                    className={classes.img}
                                    alt={name}
                                />
                            )}
                            actual={({ imageProps }) => (
                                <img
                                    {...imageProps}
                                    className={classes.img}
                                    alt={name}
                                />
                            )}
                        />
                    }
                >
                    <div className={classes.popupContent}>
                        <div className={classes.rating}>
                            {!!rating ? (
                                <div className={classes.noRating}>
                                    Рейтинг: {position} место
                                </div>
                            ) : (
                                <div className={classes.noRating}></div>
                            )}
                        </div>
                        <div
                            className={classes.textWrapper}
                            onClick={onReviewClick}
                        >
                            <span className={classes.primaryText}>
                                {texts.REVIEWS}
                            </span>
                            <span className={classes.secondaryText}>
                                {reviewsCounter}
                            </span>
                        </div>
                    </div>
                </PurplePopup>
            )}
        </div>
    );
}

export default withStyles(styles)(ProviderLogo);
